export default "__VITE_ASSET__CugRk8zy__"